// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scale-reduce[data-v-a972a762] {\n  -webkit-transform: scale(0.625);\n          transform: scale(0.625);\n  -webkit-transform-origin: 50% 80%;\n          transform-origin: 50% 80%;\n}\n.inactive[data-v-a972a762] {\n  background: #f6f4f4;\n}\n[data-v-a972a762] .selected-row {\n  background: #e2f5fb;\n}\ntr:hover .copy-rule[data-v-a972a762] {\n  visibility: visible;\n}", ""]);
// Exports
module.exports = exports;
